import axios, { type AxiosInstance } from 'axios';
import { attachInterceptors } from './interceptors.js';
import type { CreateApiClientConfig } from './types.js';

/**
 * Factory: cria um AxiosInstance pre-configurado com auth, retry, refresh e mapping de erros.
 * Callers preservam a API publica do axios (use `instance.get/post/...`) e
 * podem expor a instancia como `api`/`axios` no layout.
 */
export function createApiClient(config: CreateApiClientConfig): AxiosInstance {
  const instance = axios.create({
    baseURL: config.baseUrl,
    timeout: config.timeoutMs ?? 30000,
    headers: {
      'Content-Type': 'application/json',
      ...(config.defaultHeaders ?? {}),
    },
    adapter: config.adapter,
  });

  attachInterceptors(instance, config);
  // Axios serializes FormData as JSON if the shared default is left in place.
  // Let the transport generate the multipart boundary for native file uploads.
  instance.interceptors.request.use((request) => {
    if (typeof FormData !== 'undefined' && request.data instanceof FormData) {
      request.headers.delete('Content-Type');
    }
    return request;
  });
  return instance;
}
